import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { OutsideClick } from 'wanderu-hocs';

import DropdownArrow from '../DropdownArrow/DropdownArrow';

import styles from './DropdownMenu.scss';

class DropdownMenu extends React.Component {
    static propTypes = {
        alwaysRendered: PropTypes.bool,
        altText: PropTypes.string,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
        ]),
        checkmark: PropTypes.bool,
        onToggleMenu: PropTypes.func,
        showArrow: PropTypes.bool,
    };

    static defaultProps = {
        alwaysRendered: false,
        checkmark: false,
        onToggleMenu() {},
        showArrow: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    _closeMenu = () => {
        this.setState(() => ({
            isOpen: false,
        }));
    };

    _toggleMenu = () => {
        this.props.onToggleMenu(this.state.isOpen);
        this.setState((oldState) => ({
            isOpen: !oldState.isOpen,
        }));
    };

    _augmentChild = (child) => {
        return React.cloneElement(child, {
            ...child.props,
            onComplete: this._closeMenu,
        });
    };

    _renderContents = () => {
        const {
            altText,
            alwaysRendered,
            children,
            title,
            className,
            checkmark,
            showArrow,
        } = this.props;
        const { isOpen } = this.state;
        const shouldRender = isOpen || alwaysRendered;

        return (
            <React.Fragment>
                <div
                    aria-label={altText}
                    aria-pressed={isOpen}
                    className={classNames(
                        className,
                        styles.toggle,
                    )}
                    onClick={this._toggleMenu}
                    role="button"
                    title={altText}
                >
                    <span className={styles.title}>
                        {title}
                    </span>
                    {showArrow && (
                        <DropdownArrow
                            checkmark={checkmark}
                            isOpen={isOpen}
                        />
                    )}
                </div>
                {shouldRender && (
                    <div
                        className={classNames(
                            styles.menu,
                            { [styles.hidden]: alwaysRendered && !isOpen },
                        )}
                    >
                        {React.Children.map(children, this._augmentChild)}
                    </div>
                )}
            </React.Fragment>
        );
    };

    render() {
        const { isOpen } = this.state;

        if (isOpen) {
            return (
                <OutsideClick
                    cancelOutsideClick={false}
                    className={styles.container}
                    onOutsideClick={this._closeMenu}
                >
                    {this._renderContents()}
                </OutsideClick>
            );
        }

        return this._renderContents();
    }
}

export {
    DropdownMenu,
};

export default DropdownMenu;
